const DEFAULT_CHAIN_CONFIG = {
  projectId: '5c2c5f16be639076ab823b176d225e9d',
  contracts: {
    deposit: '0xb81a6297F3e3B831a2C07DEE098cec0BA81BBD86',
    withdrawUsdt: '0xb81a6297F3e3B831a2C07DEE098cec0BA81BBD86',
    //withdrawToken: '0xf02fC63dc38452e4786a33653E89CE480DA811F9',
    withdrawToken: '0x44E4dECacD2B4C18176700aD66d4EC506E5B802d',
    usdt: '0x55d398326f99059fF775485246999027B3197955'
  },
  fees: {
    depositBnb: '0.0002',
    withdrawBnb: '0.0002'
  },
  selectors: {
    allowance: '0xdd62ed3e',
    approve: '0x095ea7b3',
    deposit: '0xb6b55f25',
    balanceOf: '0x70a08231'
  },
  signatures: {
    withdrawUsdt: '0x529d1cd7',
    withdrawToken: 'withdrawToken(uint256,uint256,bytes)'
  }
}

function mergeDeep(base, patch) {
  const p = patch && typeof patch === 'object' ? patch : null
  if (!p) return base
  const out = Array.isArray(base) ? base.slice() : { ...base }
  Object.keys(p).forEach((k) => {
    const pv = p[k]
    if (pv && typeof pv === 'object' && !Array.isArray(pv) && base && typeof base[k] === 'object' && !Array.isArray(base[k])) {
      out[k] = mergeDeep(base[k], pv)
    } else {
      out[k] = pv
    }
  })
  return out
}

let RUNTIME_CHAIN_CONFIG = null
try {
  if (typeof window !== 'undefined' && window.__EQUINOX_CHAIN_CONFIG__) {
    RUNTIME_CHAIN_CONFIG = window.__EQUINOX_CHAIN_CONFIG__
  }
} catch (e) {}

// export const CHAIN_CONFIG = mergeDeep(DEFAULT_CHAIN_CONFIG, RUNTIME_CHAIN_CONFIG)
export const CHAIN_CONFIG = DEFAULT_CHAIN_CONFIG
